import * as yup from 'yup';

import { DocumentItem } from './types';

export const DocumentItemSchema: yup.ObjectSchema<DocumentItem> = yup.object({
  name: yup.string().defined(),
  contentType: yup.string().required(),
  path: yup.string().defined(),
  modifiedBy: yup.string().required(),
  modifiedAt: yup.date().required(),
  children: yup
    .array()
    .of(yup.lazy(() => DocumentItemSchema))
    .nullable(),
  webUrl: yup.string(),
  appUrl: yup.string(),
});
